export default {
  header: {
    title: 'Käytä pisteitäsi',
    balance: '{{value}} pistettä käytettävissä',
  },
  option_label: '{{value}} pistettä',
  buttons: {
    none: 'Ei mitään',
  },
  toasts: {
    enabled: 'Kanta-asiakaspisteet lisätty onnistuneesti',
    removed: 'Kanta-asiakaspisteet poistettu',
  },
};
